import wilds from "../assets/bonus/wilds.png";

export default function BonusGame({ title, text }) {
  return (
    <div className="wrapper">
      <div className="content">
        <div className="title">{title}</div>
        <div style={{ margin: "auto" }}>{text[0]}</div>
        <br />
        <div className="img_box">
          <img src={wilds} alt="" />
        </div>
        <br />
        <div style={{ margin: "auto" }}>{text[1]}</div>
      </div>
    </div>
  );
}
